module.exports = __webpack_public_path__ + "assets/img/07720cca351dd3337f4673c47f323740.svg";